export default {"src":"/_next/static/media/outdoor_64.a0aac530.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};